import React from 'react';

import { clearCanvasContext, getCanvasContent } from './canvas_helpers';

interface BaseCanvasProps {
  id: string;
  text: string;
  fontFamily: string;
  fontSize: number;
  onDataChange: (dataUrl: string, textWidth: number) => void;
}

export const CANVAS_SIGNATURE_COMPONENT_HEIGHT = 42;

const BaseCanvas: React.FC<BaseCanvasProps> = React.memo(
  ({ id, text, fontFamily, fontSize, onDataChange }) => {
    const canvasRef = React.useRef<HTMLCanvasElement | null>(null);
    const onDataChangeRef = React.useRef(onDataChange);

    React.useEffect(() => {
      onDataChangeRef.current = onDataChange;
    }, [onDataChange]);

    React.useEffect(() => {
      if (canvasRef.current) {
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');
        if (context) {
          if (text?.length > 0) {
            const canvasContent = getCanvasContent(
              canvas,
              context,
              fontSize,
              fontFamily,
              text,
            );
            if (canvasContent) {
              const { width, dataUrl } = canvasContent;
              onDataChangeRef.current(dataUrl, width);
            }
            return;
          }
          // if the text is empty we should clear the canvas
          canvas.width = 0;
          canvas.height = 0;
          clearCanvasContext(canvas, context);
        }
      }
    }, [fontFamily, fontSize, text]);

    return <canvas id={id} ref={canvasRef} height={0} width={0} />;
  },
);

export default BaseCanvas;
